import { addBreadcrumb } from "@/common/helpers/sentryHelper";
import { ServerEvent, NotificationContext } from "@/common/notification";
import { useCallback, useContext, useEffect, useRef } from "react";

export type HookAction<T> = (data: T) => void;

export const notificationListener = <T>(
	event: ServerEvent,
	action: HookAction<T>
) => {
	const notificationManager = useContext(NotificationContext);
	const actionRef = useRef<HookAction<T>>(action);

	if (actionRef.current !== action) {
		actionRef.current = action;
	}

	const actionCallback = useCallback((data: any) => {
		addBreadcrumb("websocket_event", `Event of type ${event} received`, data);
		actionRef.current(data);
	}, []);

	useEffect(() => {
		notificationManager.subscribe(event, actionCallback);

		return () => {
			notificationManager.unsubscribe(event, actionCallback);
		};
	}, [actionCallback]);
};
